"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TouchableItem = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_native_1 = require("react-native");
const hooks_1 = require("../../hooks");
// import BorderlessButton from './BorderlessButton';
const ANDROID_VERSION_LOLLIPOP = 21;
/**
 * TouchableItem renders a touchable that looks native on both iOS and Android.
 *
 * It provides an abstraction on top of TouchableNativeFeedback and
 * TouchableOpacity.
 *
 * On iOS you can pass the props of TouchableOpacity, on Android pass the props
 * of TouchableNativeFeedback.
 *
 * Code taken from react-navigation project
 */
const TouchableItem = (props) => {
    const View = hooks_1.useComponent('View');
    /*
     * TouchableNativeFeedback.Ripple causes a crash on old Android versions,
     * therefore only enable it on Android Lollipop and above.
     *
     * All touchables on Android should have the ripple effect according to
     * platform design guidelines.
     * We need to pass the background prop to specify a borderless ripple effect.
     */
    if (react_native_1.Platform.OS === 'android' && react_native_1.Platform.Version >= ANDROID_VERSION_LOLLIPOP) {
        const { style } = props, rest = tslib_1.__rest(props, ["style"]);
        return (react_1.default.createElement(react_native_1.TouchableNativeFeedback, Object.assign({}, rest, { style: null, background: react_native_1.TouchableNativeFeedback.Ripple(props.pressColor, props.borderless) }),
            react_1.default.createElement(View, { style: style }, react_1.default.Children.only(props.children))));
    }
    else if (react_native_1.Platform.OS === 'ios') {
        // FIXME: Add borderless button
        return (react_1.default.createElement(react_native_1.TouchableOpacity, Object.assign({ hitSlop: { top: 10, bottom: 10, right: 10, left: 10 } }, props), props.children));
        // return (
        //   <BorderlessButton
        //     hitSlop={{ top: 10, bottom: 10, right: 10, left: 10 }}
        //     disallowInterruption={true}
        //     {...props}
        //   >
        //     {props.children}
        //   </BorderlessButton>
        // );
    }
    else {
        return react_1.default.createElement(react_native_1.TouchableOpacity, Object.assign({}, props), props.children);
    }
};
exports.TouchableItem = TouchableItem;
exports.TouchableItem.displayName = 'TouchableItem';
exports.TouchableItem.defaultProps = {
    borderless: false,
    pressColor: 'rgba(0, 0, 0, .32)', // TODO: Extract this from theme
};
